module.exports = __webpack_public_path__ + "media/post-registration/create-event@1x-342174b3.png";